import Api from "./Api";

const abortKey = "FiBuSuSaApi";
const endpoint = "/fibu/susa";
export default {
    abort() {
        Api.abort(abortKey);
    },
    getFinanzkonten(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(
            endpoint + "/finanzkonten",
            usedParams,
            true,
            false,
            abortKey
        );
    },
    getBuchungskonten(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(
            endpoint + "/buchungskonten",
            usedParams,
            true,
            false,
            abortKey
        );
    },
    printSuSaView(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(
            endpoint + "/drucken",
            usedParams,
            true,
            false,
            abortKey
        );
    }
};
